const classNames = (...classes) => classes.filter(Boolean).join(' ');
export default classNames;
